import { render } from "./GoodLink.vue?vue&type=template&id=3a2427b6"
import script from "./GoodLink.vue?vue&type=script&lang=js"
export * from "./GoodLink.vue?vue&type=script&lang=js"

import "./GoodLink.vue?vue&type=style&index=0&id=3a2427b6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__